export const Mode = {
  Expanded: 'expanded',
  Collapsed: 'collapsed',
  Hidden: 'hidden',
};
